import gql from "graphql-tag";
const CHATS = gql`
	subscription notifications($token: String!) {
		onChatAdded(token: $token) {
			id
			name
			lastMessage {
				id
				createdOn
				isSeen
				text
				files {
					id
					name
					contentType
					extension
				}
			}
			participants {
				id
				contact {
					id
					name
					photoId
				}
				lastViewedOn
			}
		}
	}
`;
const MESSAGE_ADDED_HEADER = gql`
	subscription messages($token: String!) {
		onMessageAdded(token: $token) {
			message {
				id
			}
		}
	}
`;
const MESSAGE_ADDED = gql`
	subscription messages($token: String!) {
		onMessageAdded(token: $token) {
			message {
				id
				text
				isSeen
				replyToMessage {
					id
					text
					createdOn
					isSeen
					contactId
					files {
						id
						name
						typeId
						extension
						contentType
						duration
					}
				}
				chatId
				createdOn
				contactId
				files {
					id
					name
					typeId
					extension
					contentType
					duration
					data
				}
			}
			isMute
		}
	}
`;
const ONLINE_STATUS = gql`
	subscription onlineStatus($token: String!) {
		onContactOnlineStatusChanged(token: $token) {
			contactId
			isOnline
		}
	}
`;
const MESSAGE_CHANGED = gql`
	subscription messages($token: String!) {
		onMessageChanged(token: $token) {
			message {
				id
				text
				isSeen
				isDeleted
				files {
					id
					name
					typeId
					extension
					contentType
					duration
				}
			}
			isMute
		}
	}
`;
const UNREAD_MESSAGES_COUNT_CHANGED = gql`
	subscription unreadMessages($token: String!) {
		totalCount: onUnreadMessagesCountChanged(token: $token)
	}
`;
const TOKEN_CHANGED = gql`
	subscription tokenChanged($token: String!) {
		onTokenChanged(token: $token) {
			status
			message
			token
			expiration
			contact
			roles
			policies
		}
	}
`;
export {
  CHATS,
  MESSAGE_ADDED,
  MESSAGE_ADDED_HEADER,
  MESSAGE_CHANGED,
  ONLINE_STATUS,
  TOKEN_CHANGED,
  UNREAD_MESSAGES_COUNT_CHANGED
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
